import { z } from 'zod';

// ! 👇 Contract with HIP EDA: `ERRORCODE` of a rejected NOTIFICATION_ACK. Messages stay in English
// TODO: Need to test to validate with SAP
export enum SapErrorCodeEnum {
  IW_PLANT_UNKNOWN = 'IW_PLANT_UNKNOWN', // plant does not exist for the site
  FUNCTIONAL_LOCATION_UNKNOWN = 'FUNCTIONAL_LOCATION_UNKNOWN',
  FUNCTIONAL_LOCATION_DELETED = 'FUNCTIONAL_LOCATION_DELETED', // flagged for deletion
  EQUIPMENT_UNKNOWN = 'EQUIPMENT_UNKNOWN',
  EQUIPMENT_LOCATION_MISMATCH = 'EQUIPMENT_LOCATION_MISMATCH', // not installed on the location
  NOTIFICATION_TYPE_INVALID = 'NOTIFICATION_TYPE_INVALID',
  PRIORITY_INVALID = 'PRIORITY_INVALID',
  SYMPTOM_CODE_INVALID = 'SYMPTOM_CODE_INVALID',
  PLANNER_GROUP_INVALID = 'PLANNER_GROUP_INVALID',
  DATE_INVALID = 'DATE_INVALID',
  MANDATORY_FIELD_MISSING = 'MANDATORY_FIELD_MISSING',
  TEXT_TOO_LONG = 'TEXT_TOO_LONG',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED', // the technical user lacks the authorization
  DUPLICATE_NOTIFICATION = 'DUPLICATE_NOTIFICATION', // same NOTIFICATIONID already processed
  SAP_UNAVAILABLE = 'SAP_UNAVAILABLE',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}

export const sapErrorCodeSchema = z.enum(SapErrorCodeEnum);
